import List from '../../containers/MistakeTypes/List';
import Edit from '../../containers/MistakeTypes/Edit';
import Create from '../../containers/MistakeTypes/Create';
import Show from '../../containers/MistakeTypes/Show';

export default { List, Edit, Create, Show };
